import axios from 'axios';

const getConstratacoes = (params) => axios.get('/transportador/contratacoes-fretes', {
  params,
});

const getConstratacoesList = (params) => axios.get('/transportador/contratacoes-fretes/list', {
  params,
});

const getContratacao = (id) => axios.get(`/transportador/contratacoes-fretes/${id}`);
const cancelar = (id, data) => axios.put(`/transportador/contratacoes-fretes/${id}/cancelar`, data);

const aprovar = (id) => axios.put(`transportador/contratacoes-fretes/${id}/aprovar`, {});

const notificarNegociacao = (id) => axios.post(`/notificacoes/contrato_frete/${id}`, {});

export default {
  getConstratacoes,
  getConstratacoesList,
  getContratacao,
  cancelar,
  aprovar,
  notificarNegociacao,
};
